/** Paying people API endpoints, merged into the platform API client. */
export const payApiEndpoints: Record<string, string> = {
  payDetails: "/ext/pay/details/",
  savePayDetails: "PUT:/ext/pay/details/",
  removePayDetails: "DELETE:/ext/pay/details/",
  payBanks: "/ext/pay/banks/",
  payConnections: "/ext/pay/connections/",
  savePayConnection: "PUT:/ext/pay/connections/:kind/",
  removePayConnection: "DELETE:/ext/pay/connections/:kind/",
  payPlatform: "/ext/pay/platform/",
  savePlatformPayConnection: "PUT:/ext/pay/platform/connections/:kind/",
  removePlatformPayConnection: "DELETE:/ext/pay/platform/connections/:kind/",
  savePayAllowance: "PUT:/ext/pay/platform/allowances/:pk/",
  releasePayRequest: "POST:/ext/pay/platform/requests/:pk/release/",
  declinePayRequest: "POST:/ext/pay/platform/requests/:pk/decline/",
  payRuns: "/ext/pay/runs/",
  payRun: "/ext/pay/runs/:pk/",
  sendPayRun: "POST:/ext/pay/runs/:pk/send/",
  refreshPayRun: "POST:/ext/pay/runs/:pk/refresh/",
};
